import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Observable } from 'rxjs/internal/Observable';


@Component({
  selector: 'intelli-text-editor',
  templateUrl: './intelli-text-editor.component.html',
  styleUrls: ['./intelli-text-editor.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: IntelliTextEditorComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliTextEditorComponent implements MatFormFieldControl<string>, ControlValueAccessor {


  static nextId = 0;
  mainForm: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'intelli-text-editor';
  id = `intelli-text-editor-${IntelliTextEditorComponent.nextId++}`;
  describedBy = '';

  @Input() public type:string = "text";

  private onChangeValue: (value: string) => void;


  writeValue(obj: string): void {
    this.value = obj;
  }
  registerOnChange(onChange: (value: string) => void): void {

    this.onChangeValue = onChange;

    this.InitializeAutocompleteControls();
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.mainForm.get("textControlName").disable();
    }
    else {
      this.mainForm.get("textControlName").enable();
    }
  }


  get empty() {
    // const { value: { textControlName } } = this.mainForm;


    // return textControlName == null;
    let value = this.mainForm.get("textControlName").value;

    if(value == "" || value ==null)
    {
      return true;
    }
 
    return false;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);

    if (this._disabled)
      this.mainForm.get("textControlName").disable()
    else
      this.mainForm.get("textControlName").enable()

    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): string | null {

    return this.mainForm.get("textControlName").value;

  }

  set value(value: string | null) {

    value = value || "";
    this.mainForm.get("textControlName").setValue(value);

    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder, private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.mainForm = fb.group({
      textControlName: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });


    // this.InitializeAutocompleteControls();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

  }


  displayVendorFn(vendor?: any): string | undefined {

    return vendor ? vendor.Name : undefined;
  }

  public InitializeAutocompleteControls(): void {

    this.mainForm.get("textControlName").valueChanges
      .subscribe(data => {

        this.onChangeValue(this.value);

      })


  }


  // public compareFn: ((f1: any, f2: any) => boolean) | null = this.compareByValue;

  // compareByValue(f1: any, f2: any) {

  //   return f1 === f2;
  // }

}